module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup",
    on: {
      "click": function($event) {
        return _vm.hideMe()
      }
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "popuptext",
    attrs: {
      "id": "myPopup"
    }
  }, [_c('p', [_vm._v("Wprowadzone przez Ciebie dane zostały już zarejestrowane w naszym systemie. W celu ich zmiany skontaktuj się z działem Call Center pod numerem telefonu:"), _c('br'), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("(22) 307 68 98.")])]), _vm._v(" "), _c('i', {
    staticClass: "ion-android-close"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d2dc420","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FinishedOrderPopup.vue
// module id = 256
// module chunks = 1